export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isVirtualCategory () {
      return (this.productType === 'AppointmentProduct' || this.productType === 'AppointmentWithDoctorProduct' ||
      this.productType === 'PackageOfServicesProduct' || this.productType === 'OneTimeServiceProduct' || this.productType === 'MedicalCheckProduct') &&
        !!this.getVirtualCategoryByRoute.length
    },

    getVirtualCategoryByRoute () {
      const { virtual: virtualParams, slug } = this.$route.params
      const routeParamsUrl = [slug, virtualParams].join('/')

      return this.product.virtualCategories?.filter(item => item.url === routeParamsUrl) || false
    },
  },
}
